/* eslint-disable no-unused-vars */
import React from 'react';
import {Title, Image, Paragraph, Slideshow} from './../../Basics';
import Particle from './../../Particle';
/* eslint-enable no-unused-vars */

const Particle12 = () => (<div>

  <Title>Die Aufgaben mit Armprothese</Title>
  <Slideshow>
    <section>
      <Image
        source={require('./12_Bild_1_ARM_Team_DIPO-Power_NicolaPitaro_7667.jpg')}
        title='Impression Heisser Draht'
        caption={
          <span>
            <b>Heisser Draht</b>
              Die Teilnehmer mussten den Ring entlang des gebogenen Metalldrahts führen,
              ohne diesen zu berühren. Eine schwierige Aufgabe – fast alle Teilnehmer
              scheiterten.
          </span>
        }
      />
    </section>

    <section>
      <Image
        source={require('./12_Bild_2_ARM_Team_Imperial_NicolaPitaro_7627.jpg')}
        title='Impression Puzzle mit Holzplatten'
        caption={
          <span>
            <b>Puzzle mit Holzplatten</b>
            Die Platten haben verschiedene Griffe, die mit der Prothesenhand gefasst
            werden mussten. Verschiedene Griffformen erfordern verschiedene Greiftechniken.
          </span>
        }
      />
    </section>

    <section>
      <Image
        source={require('./12_Bild_3_ARM_Team-Imperial_AlessandroDellaBella_083.jpg')}
        title='Impression Glühbirne einschrauben'
        caption={
          <span>
            <b>Glühbirne einschrauben</b>
            Teilnehmer mussten die Glühbirne mit der Prothesenhand in die Fassung
            drehen, ohne sie zu zerdrücken.
          </span>
        }
      />
    </section>

    <section>
      <Image
        source={require('./12_Bild_4_ARM_Team_Meltin-MMI_NicolaPitaro_7660.jpg')}
        title='Impression Schwere Objekte'
        caption={
          <span>
            <b>Schwere Objekte</b>
            Eine Schachtel, eine gefüllte Giesskanne und eine Getränkekiste mussten beidhändig über
            ein Treppenhindernis getragen und auf einem Tisch abgestellt werden.
          </span>
        }
      />
    </section>

    <section>
      <Image
        source={require('./12_Bild_5_ARM_Team_SoftHand-Pro_NicolaPitaro_6458.jpg')}
        title='Impression Alltägliche Aufgaben'
        caption={
          <span>
            <b>Alltägliche Aufgaben</b>
            Schon nur eine Scheibe Brot abzuschneiden oder eine Dose zu öffnen ist
            für Menschen mit Armprothese sehr schwierig. Fotos: ETHZ
          </span>
        }
      />
    </section>
  </Slideshow>

  <Particle
    number={26}
  />

</div>);

export default Particle12;



/** WEBPACK FOOTER **
 ** ./src/Particles/Particle12/Particle12.js
 **/